import { gql } from '@apollo/client';

export const FINISH_FIELD_SESSION_MUTATION = gql`
  mutation FinishFieldSessionMutation($input: FinishedFieldSessionInput!) {
    finishFieldSession(input: $input) {
      ... on FinishFieldSessionSuccess {
        fieldSession {
          id
          clientId
          createdAt
          updatedAt
          startedAt
          endedAt
          siteId
          siteName
          name
          note
          activeDurationSeconds
          distanceMeters
          findCount
          track
          finds {
            id
            foundAt
            name
            latitude
            longitude
          }
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
